import React, { useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  TextField,
  Button,
  Typography,
  Container,
  Alert,
  CircularProgress,
} from '@mui/material';
import { ArrowRight as ArrowRightIcon, Security as SecurityIcon } from '@mui/icons-material';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import config from '../config';

const VerifyCode = ({ onLogin }) => {
  const [code, setCode] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!code) {
      toast.error('Please enter the verification code');
      return;
    }

    const phone = localStorage.getItem('phone_number');
    const phone_code_hash = localStorage.getItem('phone_code_hash');

    if (!phone || !phone_code_hash) {
      toast.error('Session expired. Please login again.');
      navigate('/login');
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(`${config.API_BASE}/verify`, {
        phone,
        code,
        phone_code_hash,
        password: password || null
      });
      
      if (response.data.access_token) {
        onLogin(response.data.access_token);
        toast.success('Login successful!');
      } else {
        toast.error('No token received from server');
      }
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Verification failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Card sx={{ width: '100%', borderRadius: 3, bgcolor: 'background.paper' }}>
          <CardContent sx={{ p: 4 }}>
            <Box sx={{ textAlign: 'center', mb: 4 }}>
              <SecurityIcon sx={{ fontSize: 64, color: 'primary.main', mb: 2 }} />
              <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
                Verify Code
              </Typography>
              <Typography color="textSecondary">
                Enter the code sent to your Telegram
              </Typography>
            </Box>

            <Alert severity="warning" sx={{ mb: 3, borderRadius: 2 }}>
              Check your Telegram app for the verification code
            </Alert>

            <form onSubmit={handleSubmit}>
              <TextField
                fullWidth
                label="Verification Code"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                placeholder="12345"
                sx={{ mb: 2 }}
                disabled={loading}
                required
              />

              <TextField
                fullWidth
                label="2FA Password (if enabled)"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Optional"
                sx={{ mb: 3 }}
                disabled={loading}
              />

              <Button
                fullWidth
                size="large"
                variant="contained"
                type="submit"
                disabled={loading}
                sx={{ py: 1.5, borderRadius: 2 }}
              >
                {loading ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  <>
                    Verify & Login
                    <ArrowRightIcon sx={{ ml: 1 }} />
                  </>
                )}
              </Button>
            </form>

            <Button
              fullWidth
              sx={{ mt: 2 }}
              onClick={() => navigate('/login')}
              disabled={loading}
            >
              Back to Login
            </Button>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};

export default VerifyCode;